export default function RedFlagNegativeIco({ color }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill={color || "#F79009"} />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66536 4.33313C6.48127 4.33313 6.33203 4.48237 6.33203 4.66646V11.3331C6.33203 11.5172 6.48127 11.6665 6.66536 11.6665C6.84946 11.6665 6.9987 11.5172 6.9987 11.3331V9.2308L11.2834 7.62403C11.8602 7.40773 11.8602 6.59189 11.2834 6.37559L6.9987 4.76881V4.66646C6.9987 4.48237 6.84946 4.33313 6.66536 4.33313ZM6.9987 5.48081V8.5188L10.8829 7.06224C10.9406 7.04061 10.9406 6.95902 10.8829 6.93739L6.9987 5.48081Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
      />
      <path d="M11.5 7L7 5V9L11.5 7Z" fill="white" />
    </svg>
  );
}
